var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsVinNumberWindowVehicle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "der5ce6xza",
    d: "M30.999 1.598v3.175h-7.053c-1.956 0-3.81.911-5.006 2.447l-.16.213L3.9 26.998h6.4L21.323 12.53c.606-.849 1.488-1.337 2.433-1.399l.203-.006H31v3.173l-7.044.001-3.625 4.761 6.653 7.936h23.814l-.001-3.198h3.175v25.423H6.384c-3.45 0-6.26-2.735-6.38-6.155L0 42.837v-15.84L16.198 5.59c1.724-2.416 4.475-3.887 7.43-3.985l.318-.006h7.053zm19.798 28.574H3.174v12.701c0 1.693 1.325 3.076 2.995 3.17l.18.004h44.448V30.172zm-32.634-8.266l-3.875 5.092h8.186l-4.311-5.092zM44.799 0c6.185 0 11.2 5.015 11.2 11.2 0 6.186-5.014 11.2-11.2 11.2-6.185 0-11.2-5.014-11.2-11.2 0-6.185 5.015-11.2 11.2-11.2zm0 3.2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm4.195 3.93c.295.211.389.609.235.93l-.054.093-4.605 6.259c-.234.349-.699.416-1.017.17l-.076-.068-3.669-3.77c-.279-.287-.279-.753 0-1.04.255-.26.652-.283.931-.07l.08.07 3.063 3.147L48 7.317c.224-.334.67-.417.994-.186z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-475 -517) translate(258 288) translate(157 229) translate(60) translate(4 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fdwyntftub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#der5ce6xza"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#00095B",
    xlinkHref: "#der5ce6xza"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00095B",
    mask: "url(#fdwyntftub)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L64 0 64 64 0 64z",
    transform: "translate(-4 -7)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVinNumberWindowVehicle);
export default __webpack_public_path__ + "static/media/icons-vin-number-window-vehicle.f823968e91ca7812aba56b4cdb17f4e7.svg";
export { ForwardRef as ReactComponent };